import TabPage from "./TabPage";
import { StreaksTable } from "@components/RanksLevelsTable";

const DailyAchievements = () => (
    <TabPage tabKey="daily">
        <StreaksTable />
    </TabPage>
);

export default DailyAchievements;
